// extracted by mini-css-extract-plugin
export default {"button-primary-action":"ZKoDc948hGX534_sMB4a","button-secondary-action":"mf1ffgAbRhwk_XMtCdhm","button-tertiary-action":"fTy3zucDkHGxqHfyRlcQ","notification":"mVVG2ii4tk60Y64OR3I1"};